import { useMemo } from "react";

import { ApiService } from "pwapi";

import { useSelectedLabStation } from "hooks/useSelectedLabStation";

import {
  InsurancePlanOption,
  mapInsurancePlansToOptions,
} from "./SelectSearchOptions";

const useInsuranceInputs = ({
  parentResource,
  isAdmin,
}: {
  parentResource?: string;
  isAdmin?: boolean;
}) => {
  const updatedPrefix = parentResource ? `${parentResource}.` : "";

  const getInputName = (name: string) => {
    return parentResource ? `${updatedPrefix}${name}` : name;
  };

  const labStation = useSelectedLabStation();

  const inputs = useMemo(() => {
    return {
      groupEmployerId: {
        id: `${updatedPrefix}insurance__group_employer_id`,
        name: getInputName("group_employer_id"),
        label: "Group Employer ID",
      },
      policyNumber: {
        id: `${updatedPrefix}insurance__policy_number`,
        name: getInputName("policy_number"),
        label: "Policy Number",
      },
      insurancePlan: {
        id: `${updatedPrefix}plan`,
        name: getInputName("plan"),
        label: "Insurance Plan",
        debounceTime: 500,
        inputLimit: 3,
        component: InsurancePlanOption,
        mapToOptions: mapInsurancePlansToOptions,
        serviceFunction: isAdmin
          ? (args: Parameters<typeof ApiService.listAdminInsurancePlans>[0]) =>
              ApiService.listAdminInsurancePlans({
                ...args,
              })
          : (args: Parameters<typeof ApiService.listLisInsurancePlans>[0]) =>
              ApiService.listLisInsurancePlans({
                ...args,
                parentLookupLabStationId: labStation?.id,
              }),
        filter: "searchTerm",
      },
      insuranceCompanyName: {
        id: `${updatedPrefix}insurance__company_name`,
        name: getInputName("insurance_company_name"),
        label: "Insurance Company Name",
      },
      hasAbn: {
        id: `${updatedPrefix}has_abn`,
        name: getInputName("has_abn"),
        label: "Has ABN",
        type: "checkbox",
      },
      preapprovalID: {
        id: `${updatedPrefix}preapproval_id`,
        name: getInputName("preapproval_id"),
        label: "Preauthorization ID",
      },
    };
  }, []);

  return inputs;
};

export default useInsuranceInputs;
